// extracted by mini-css-extract-plugin
export var equalColumn = "_gy-0";